import { useAuth } from '../../context/AuthContext';
import { useEventsOrganizations } from './api/queries';

/**
 * Whether the top-level Events entry is shown: only when organizations/
 * lists an organization with events enabled, whichever store is selected.
 * Reconciliation-only organizations are deliberately not advertised; their
 * directors reach /events/reconciliation directly. Until organizations/
 * resolves (or if it fails), the selected store's flag is used.
 */
export function useEventsEntryVisible(): boolean {
  const { user, userInfoSettled } = useAuth();
  const organizations = useEventsOrganizations({ enabled: Boolean(user) });

  if (!user) return false;
  if (organizations.data) {
    return organizations.data.some((organization) => organization.enabled);
  }
  return userInfoSettled && user.events_platform_enabled === true;
}
